import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './../node_modules/bulma/css/bulma.css';
import VueCookies from "vue-cookies";
import { VueShowdownPlugin } from 'vue-showdown';


createApp(App,{
    data() {
        return {
          count: 0
        }
      }
})
.use(router)

.use(VueCookies).use(VueShowdownPlugin, {
  options: {
    emoji: true,
  }
}).mount('#app')
